/* export const API_URL = "https://api.umrlice.vijesti.me"; */
export const UMRLICE_LARAVEL_API_TOKEN = "e6dfcdd0d0e693508e7f14ad1841cfe8";

export const API_URL = "https://api.umrlice.vijesti.me";
